/**
 * Links the menu points at that are set per deployment. An empty value hides its link.
 */

/** The community Discord invite (e.g. https://discord.gg/abc123). Empty until there is one: the bottom bar's Discord link stays hidden. */
export const DISCORD_URL = '';
